module.exports = __webpack_public_path__ + "img/image112.90f8b30e.jpg";